// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pos-top-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
  padding: 10px 12px;
  border: 1px solid #e3e9f4;
  border-radius: 12px;
  background: #ffffff;
}

.pos-top-actions__left,
.pos-top-actions__right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.pos-top-actions__right {
  direction: rtl;
}

.pos-top-actions__time {
  min-width: 185px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #dce5f3;
  border-radius: 9px;
  background: #f7faff;
  color: #4b5563;
  font-size: 13px;
  font-weight: 700;
  gap: 6px;
}

.pos-top-actions__time-date,
.pos-top-actions__time-clock {
  direction: ltr;
  unicode-bidi: plaintext;
}

.pos-top-actions__time-separator {
  color: #9aa6ba;
  font-weight: 600;
}

.pos-top-btn {
  min-height: 40px;
  border-radius: 9px;
  font-size: 13px;
  font-weight: 700;
  border: 1px solid transparent;
  padding-inline: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.pos-top-btn__icon {
  margin-inline-end: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.pos-top-btn--close-shift {
  background: #0fb9b1;
  color: #ffffff;
}

.pos-top-btn--close-shift:hover {
  background: #0ca29c;
  color: #ffffff;
}

.pos-top-btn--danger {
  background: #fdeff3;
  border-color: #fdeff3;
  color: #ff0000;
  width: 42px;
  min-width: 42px;
  height: 37px;
  padding: 0 !important;
  border-radius: 5px;
  box-shadow: none;
}

.pos-top-btn--danger:hover {
  background: #fbe5ec;
  border-color: #fbe5ec;
  color: #ff0000;
}

.pos-top-btn--sync {
  background: #3300ff;
  border-color: #3300ff;
  color: #9ba2c6;
  width: 43px;
  min-width: 43px;
  height: 37px;
  padding: 0 !important;
  border-radius: 4px;
  box-shadow: none;
}

.pos-top-btn--sync:hover {
  background: #2f00ea;
  border-color: #2f00ea;
  color: #9ba2c6;
}

.pos-top-btn--danger i,
.pos-top-btn--sync i {
  margin: 0 !important;
  font-size: 24px;
  width: 24px;
  height: 24px;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  transform: translateY(0);
}

/* Force icon colors to avoid inheriting Bootstrap muted text color */
.pos-top-btn--danger i {
  color: #ff0000 !important;
}

.pos-top-btn--sync i {
  color: #ffffff !important;
}

.pos-top-btn--add i,
.pos-top-btn--close-shift i {
  color: #ffffff !important;
}

.pos-top-btn--danger:disabled,
.pos-top-btn--danger[disabled],
.pos-top-btn--sync:disabled,
.pos-top-btn--sync[disabled] {
  opacity: 1;
}

.pos-top-btn--add {
  background: #3f2dff;
  color: #ffffff;
}

.pos-top-btn--add:hover {
  background: #2e1dde;
  color: #ffffff;
}

@media (max-width: 1399px) {
  .pos-top-actions {
    flex-direction: column;
    align-items: stretch;
  }
  .pos-top-actions__left,
  .pos-top-actions__right {
    justify-content: flex-start;
  }
  .pos-top-actions__right {
    direction: ltr;
  }
}
@media (max-width: 767px) {
  .pos-top-actions__time,
  .pos-top-btn,
  .pos-top-btn--danger,
  .pos-top-btn--sync {
    width: 100%;
    min-width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/scafold-container/scafold-container.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;;EAEE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,QAAA;AACF;;AAEA;;EAEE,cAAA;EACA,uBAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AACF;;AAEA;EACE,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AACF;;AAEA;;EAEE,oBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EAEA,wBAAA;AAAF;;AAGA,qEAAA;AACA;EACE,yBAAA;AAAF;;AAGA;EACE,yBAAA;AAAF;;AAGA;;EAEE,yBAAA;AAAF;;AAGA;;;;EAIE,UAAA;AAAF;;AAGA;EACE,mBAAA;EACA,cAAA;AAAF;;AAGA;EACE,mBAAA;EACA,cAAA;AAAF;;AAGA;EACE;IACE,sBAAA;IACA,oBAAA;EAAF;EAGA;;IAEE,2BAAA;EADF;EAIA;IACE,cAAA;EAFF;AACF;AAKA;EACE;;;;IAIE,WAAA;IACA,eAAA;EAHF;AACF","sourcesContent":[".pos-top-actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 8px;\n  padding: 10px 12px;\n  border: 1px solid #e3e9f4;\n  border-radius: 12px;\n  background: #ffffff;\n}\n\n.pos-top-actions__left,\n.pos-top-actions__right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.pos-top-actions__right {\n  direction: rtl;\n}\n\n.pos-top-actions__time {\n  min-width: 185px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #dce5f3;\n  border-radius: 9px;\n  background: #f7faff;\n  color: #4b5563;\n  font-size: 13px;\n  font-weight: 700;\n  gap: 6px;\n}\n\n.pos-top-actions__time-date,\n.pos-top-actions__time-clock {\n  direction: ltr;\n  unicode-bidi: plaintext;\n}\n\n.pos-top-actions__time-separator {\n  color: #9aa6ba;\n  font-weight: 600;\n}\n\n.pos-top-btn {\n  min-height: 40px;\n  border-radius: 9px;\n  font-size: 13px;\n  font-weight: 700;\n  border: 1px solid transparent;\n  padding-inline: 14px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n}\n\n.pos-top-btn__icon {\n  margin-inline-end: 6px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n}\n\n.pos-top-btn--close-shift {\n  background: #0fb9b1;\n  color: #ffffff;\n}\n\n.pos-top-btn--close-shift:hover {\n  background: #0ca29c;\n  color: #ffffff;\n}\n\n.pos-top-btn--danger {\n  background: #fdeff3;\n  border-color: #fdeff3;\n  color: #ff0000;\n  width: 42px;\n  min-width: 42px;\n  height: 37px;\n  padding: 0 !important;\n  border-radius: 5px;\n  box-shadow: none;\n}\n\n.pos-top-btn--danger:hover {\n  background: #fbe5ec;\n  border-color: #fbe5ec;\n  color: #ff0000;\n}\n\n.pos-top-btn--sync {\n  background: #3300ff;\n  border-color: #3300ff;\n  color: #9ba2c6;\n  width: 43px;\n  min-width: 43px;\n  height: 37px;\n  padding: 0 !important;\n  border-radius: 4px;\n  box-shadow: none;\n}\n\n.pos-top-btn--sync:hover {\n  background: #2f00ea;\n  border-color: #2f00ea;\n  color: #9ba2c6;\n}\n\n.pos-top-btn--danger i,\n.pos-top-btn--sync i {\n  margin: 0 !important;\n  font-size: 24px;\n  width: 24px;\n  height: 24px;\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n  // justify-content: center;\n  transform: translateY(0);\n}\n\n/* Force icon colors to avoid inheriting Bootstrap muted text color */\n.pos-top-btn--danger i {\n  color: #ff0000 !important;\n}\n\n.pos-top-btn--sync i {\n  color: #ffffff !important;\n}\n\n.pos-top-btn--add i,\n.pos-top-btn--close-shift i {\n  color: #ffffff !important;\n}\n\n.pos-top-btn--danger:disabled,\n.pos-top-btn--danger[disabled],\n.pos-top-btn--sync:disabled,\n.pos-top-btn--sync[disabled] {\n  opacity: 1;\n}\n\n.pos-top-btn--add {\n  background: #3f2dff;\n  color: #ffffff;\n}\n\n.pos-top-btn--add:hover {\n  background: #2e1dde;\n  color: #ffffff;\n}\n\n@media (max-width: 1399px) {\n  .pos-top-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .pos-top-actions__left,\n  .pos-top-actions__right {\n    justify-content: flex-start;\n  }\n\n  .pos-top-actions__right {\n    direction: ltr;\n  }\n}\n\n@media (max-width: 767px) {\n  .pos-top-actions__time,\n  .pos-top-btn,\n  .pos-top-btn--danger,\n  .pos-top-btn--sync {\n    width: 100%;\n    min-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
